import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {}
  
  renderTypeFields(event) {
    let type = $(event.target).val();
    console.log(type)
    
    Rails.ajax({
      type: 'GET',
      url: `/experiments/render_fields`,
      data: $.param({"type": type}),
      dataType: 'json',
      success: (response) => {
        $("#fields").html(response)

        $('.select2').select2({
          theme: "bootstrap4",
        });
      }
    });
  }

  AddNewField(event) {
    event.preventDefault();
    let field_name = $(event.target).data('name')
    let container = $(event.target).data('container')
    let placeholder = $(event.target).data('placeholder')

    let remove_button = "<div class='col-md-1 d-flex align-items-center'><button class='btn btn-outline-danger remove-button' type='button'><i class='fa fa-times' aria-hidden='true'></i></button></div>"
    let prompt_input = `<div class='row mt-2'>
                          <div class='col-md-8'>
                            <textarea class='form-control' cols='50' name='${field_name}' placeholder='${placeholder}' rows='4'></textarea>
                          </div>
                          ${remove_button}
                        </div>`

    $(container).append(prompt_input)
  }
  
}